import api from '@/services/api';

export default {
    postPurchaseAccess(payload) {
        return api.post(`purchase_access/`, payload).then((response) => response.data);
    },
    editPurchaseAccess(purchase_access) {
        return api
            .put(`purchase_access/${purchase_access.id}/`, purchase_access)
            .then((response) => response.data);
    },
    getPurchaseAccess(params) {
        return api.get(`purchase_access/access/`, { params }).then((response) => response.data);
    },
    postReservationAccess(data) {
        return api
            .post(`purchase_access/${data.purchase_id}/reservation/`, data)
            .then((response) => response.data);
    },
    getPurchasesAmount({ purchase_id, purchaser_id }) {
        return api
            .get('purchase_access/purchases_amount/', {
                params: { purchase_id, purchaser_id },
            })
            .then((response) => response.data);
    },
};
